import React, { useEffect } from 'react';
import './newCardForm.module.scss';
import { observer } from 'mobx-react';
import type { NewCardFormState, CardPaymentState } from './states/CardPaymentState';

type InputProps = {
  name: string;
  value: string;
  error?: string;
  placeholder: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (nextValue: string) => any;
};

const FormInput = ({ name, value, error, placeholder, onChange }: InputProps) => {
  return (
    <div styleName="form-input-wrapper">
      <input
        type="text"
        styleName="form-input"
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <div styleName="error">{error}</div>}
    </div>
  );
};

type Props = {
  state: NewCardFormState;
};

export const NewCardForm = observer(
  class NewCardForm extends React.Component<Props> {
    render() {
      const { state } = this.props;
      return (
        <div styleName="new-card-form">
          <div styleName="form-header">クレジットカード</div>
          <div styleName="number-form">
            <FormInput
              name="number"
              value={state.getValue('number')}
              error={state.getError('number')}
              placeholder="0000-0000-0000-0000"
              onChange={(v) => state.setValue('number', v)}
            />
          </div>
          <div styleName="exp-cvc">
            <FormInput
              name="exp"
              value={state.getValue('exp')}
              error={state.getError('exp')}
              placeholder="MM/YY"
              onChange={(v) => state.setValue('exp', v)}
            />
            <FormInput
              name="cvc"
              value={state.getValue('cvc')}
              error={state.getError('cvc')}
              placeholder="CVC"
              onChange={(v) => state.setValue('cvc', v)}
            />
          </div>
        </div>
      );
    }
  }
);

type NewCardFormV2Props = {
  state: CardPaymentState;
};

export const NewCardFormV2 = observer(({ state }: NewCardFormV2Props) => {
  useEffect(() => {
    state.setCardInputErrorMessage({ number: '', expiry: '' });
    const elements = payjp.elements();
    const numberElement = elements.create('cardNumber', { placeholder: '例: 1234 1234 1234 1234' });
    const expiryElement = elements.create('cardExpiry', { placeholder: '月（MM）/ 年（YY）' });
    const cvcElement = elements.create('cardCvc', { placeholder: '例：123' });
    numberElement.mount('#number-form');
    expiryElement.mount('#expiry-form');
    cvcElement.mount('#cvc-form');
    numberElement.on('change', (e) => {
      state.setCardInputErrorMessage({ number: e.error?.message || '' });
    });
    expiryElement.on('change', (e) => {
      state.setCardInputErrorMessage({ expiry: e.error?.message || '' });
    });
    state.setCardElement(numberElement);
  }, []);
  return (
    <div styleName="new-card-form">
      <div styleName="form-header">クレジットカード</div>
      <div styleName="number-form">
        <div id="number-form" styleName="payjs-outer"></div>
        <div styleName="form-error">{state.cardInputErrorMessage.number}</div>
        <div id="expiry-form" styleName="payjs-outer"></div>
        <div styleName="form-error">{state.cardInputErrorMessage.expiry}</div>
        <div id="cvc-form" styleName="payjs-outer"></div>
      </div>
    </div>
  );
});
